export class BruteForceBetlineConfig {
    public static betlines: number[][] = [
        [0, 0, 0, 0, 0], [1, 1, 1, 1, 1], [2, 2, 2, 2, 2], [3, 3, 3, 3, 3], [4, 4, 4, 4, 4], [0, 1, 2, 3, 4], [4, 3, 2, 1, 0],
        [0, 1, 2, 1, 0], [1, 2, 3, 2, 1], [2, 3, 4, 3, 2], [3, 2, 1, 2, 3], [2, 1, 0, 1, 2], [4, 3, 2, 3, 4], [0, 0, 1, 0, 0],
        [1, 1, 2, 1, 1], [2, 2, 3, 2, 2], [3, 3, 4, 3, 3], [4, 4, 3, 4, 4], [3, 3, 2, 3, 3], [2, 2, 1, 2, 2], [1, 1, 0, 1, 1]
    ]

    public static isBetlineGroupPlaying_1: boolean[][] = [
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false]
    ]

    public static isBetlineGroupPlaying_2: boolean[][] = [
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false]
    ]

    public static isBetlineGroupPlaying_3: boolean[][] = [
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false]
    ]

    public static isBetlineGroupPlaying_4: boolean[][] = [
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false]
    ]

    public static isBetlineGroupPlaying_5: boolean[][] = [
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false],
        [false, false, false, false, false]
    ]

}